var _circle, _circle2, _path, _path2, _circle3, _circle4, _circle5, _path3, _path4, _ellipse, _circle6, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostingJob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 96,
    viewBox: "0 0 131 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4851,
    cy: 44.9032,
    r: 44.9032,
    fill: "#EAF9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4853,
    cy: 44.9015,
    r: 35.0968,
    fill: "#C7DDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7182 89.1726C59.5955 93.3863 53.8455 96.0014 47.4847 96.0014C39.8924 96.0014 33.1702 92.2756 29.0469 86.5527C27.0115 92.0684 21.7074 96.0014 15.4847 96.0014C7.5033 96.0014 1.03308 89.5312 1.03308 81.5498C1.03308 73.5684 7.5033 67.0982 15.4847 67.0982C19.0961 67.0982 22.3981 68.4229 24.9314 70.6129C26.2569 59.3331 35.8488 50.582 47.4847 50.582C55.3245 50.582 62.2365 54.5547 66.3174 60.5967C69.7153 57.8823 74.0234 56.2595 78.7105 56.2595C87.3589 56.2595 94.717 61.7845 97.4475 69.4974C99.529 68.2995 101.943 67.6143 104.517 67.6143C112.073 67.6143 118.251 73.5194 118.686 80.9668C119.5 80.6759 120.377 80.5175 121.291 80.5175C125.567 80.5175 129.033 83.9837 129.033 88.2595C129.033 92.5352 125.567 96.0014 121.291 96.0014C118.342 96.0014 115.778 94.3523 114.471 91.926C111.909 94.4464 108.395 96.0014 104.517 96.0014C99.7335 96.0014 95.5028 93.6351 92.9314 90.0093C89.3228 93.7062 84.2847 96.0014 78.7105 96.0014C72.727 96.0014 67.3612 93.3567 63.7182 89.1726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03308 81.5498C1.03308 73.5684 7.5033 67.0982 15.4847 67.0982C19.0961 67.0982 22.3981 68.4229 24.9314 70.6128C26.2569 59.3331 35.8488 50.582 47.4847 50.582C55.3245 50.582 62.2365 54.5547 66.3174 60.5967C69.7153 57.8823 74.0234 56.2595 78.7105 56.2595C87.359 56.2595 94.717 61.7845 97.4475 69.4974C99.529 68.2995 101.943 67.6143 104.517 67.6143C112.073 67.6143 118.251 73.5194 118.686 80.9668C119.5 80.6759 120.377 80.5175 121.291 80.5175C125.567 80.5175 129.033 83.9837 129.033 88.2595",
    stroke: "#05587C",
    strokeWidth: 2.06618,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3237,
    cy: 26.3218,
    r: 1.54839,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.776,
    cy: 63.4854,
    r: 1.03226,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0002,
    cy: 55.4827,
    r: 2.32258,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7891 38.7078H36.6456M45.4198 34.255V29.9336",
    stroke: "#05587C",
    strokeWidth: 1.54963,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0917 35.1712L38.6704 31.75",
    stroke: "#05587C",
    strokeWidth: 1.54963,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.7421,
    cy: 93.678,
    rx: 26.0645,
    ry: 2.32258,
    fill: "#ABC0DC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1939,
    cy: 53.9362,
    r: 14.7097,
    fill: "#EAF9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3582 74.3745C62.5957 74.3745 63.655 73.9339 64.5363 73.0526C65.4175 72.1714 65.8582 71.112 65.8582 69.8745C65.8582 68.637 65.4175 67.5776 64.5363 66.6964C63.655 65.8151 62.5957 65.3745 61.3582 65.3745C60.1207 65.3745 59.0613 65.8151 58.18 66.6964C57.2988 67.5776 56.8582 68.637 56.8582 69.8745C56.8582 71.112 57.2988 72.1714 58.18 73.0526C59.0613 73.9339 60.1207 74.3745 61.3582 74.3745ZM43.3582 86.7495C42.1207 86.7495 41.0613 86.3089 40.18 85.4276C39.2988 84.5464 38.8582 83.487 38.8582 82.2495V57.4995C38.8582 56.262 39.2988 55.2026 40.18 54.3214C41.0613 53.4401 42.1207 52.9995 43.3582 52.9995H52.3582V48.4995C52.3582 47.262 52.7988 46.2026 53.68 45.3214C54.5613 44.4401 55.6207 43.9995 56.8582 43.9995H65.8582C67.0957 43.9995 68.155 44.4401 69.0363 45.3214C69.9175 46.2026 70.3582 47.262 70.3582 48.4995V52.9995H79.3582C80.5957 52.9995 81.655 53.4401 82.5363 54.3214C83.4175 55.2026 83.8582 56.262 83.8582 57.4995V82.2495C83.8582 83.487 83.4175 84.5464 82.5363 85.4276C81.655 86.3089 80.5957 86.7495 79.3582 86.7495H43.3582ZM43.3582 82.2495H79.3582V57.4995H43.3582V82.2495ZM56.8582 52.9995H65.8582V48.4995H56.8582V52.9995Z",
    fill: "#002D40"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostingJob);
export default __webpack_public_path__ + "static/media/PostingJob.cc064da01ac9cce6556c27bf858f21ac.svg";
export { ForwardRef as ReactComponent };